<template>
  <div>
    <!-- <v-row class="mt-5">
      <h4 class="mt-2 mr-5">タイプ</h4>
      <span class="mt-2">{{ items.find((e) => e.value == isType).text }}</span>
    </v-row> -->
    <component
      :is="`From${isType}`"
      :isType="isType"
      @save="hanldeUpdate"
      :loading="loading"
      confirm-ok="更新します。よろしいですか。"
      :ref="`From${isType}`"
    />
    <Dialog v-model="dialogComfirm" :width="370" :title="'確認'">
      <template v-slot:content
        >入力したデータは保存されません。続行しますか</template
      >
      <template v-slot:actions>
        <v-btn color @click="handleCancel" small>キャンセル</v-btn>
        <v-btn color="primary" small @click="handleChangeType">OK</v-btn>
      </template>
    </Dialog>
  </div>
</template>

<script>
import FromExpression from "@/views/listSection/Expression/FromAdd/FromExpression";
import FromSentence from "@/views/listSection/Expression/FromAdd/FromSentence";
const { v4: uuidv4 } = require("uuid");
import JsZip from "jszip";
import Dialog from "@/components/Dialog/Dialog";
import uploadFile from "@/utils/uploadFile";
import { updateExpression, getDetailExpression } from "@/api/Expression.api";
export default {
  store: [
    "mainExpression",
    "fieldsExpression",
    "fieldsSentence",
    "vocabularySentence",
    "tabExpression",
    "activeFieldExpression",
    "statusSentence",
    "isType",
  ],
  components: {
    FromExpression,
    FromSentence,
    Dialog,
  },
  async created() {
    this.fetchDetail();
    this.tab = "elements";
  },
  data() {
    return {
      items: [
        { text: "表現", value: "Expression" },
        { text: "文型", value: "Sentence" },
      ],
      loading: false,
      dialogComfirm: false,
      keyType: 0,
    };
  },
  methods: {
    validateTitle() {
      const { _, fieldsExpression } = this;
      var res = false;
      _.forEach(fieldsExpression, function (item) {
        if (item.key == "FormTitle" && !_.isEmpty(item.data)) {
          let value = _.find(
            item.data,
            (i) => i.fieldType == "FormElementTitle" && i.value["ja"]
          );
          console.log("value: ", value);
          if (value) return (res = true);
        }
      });
      return res;
    },
    validateValueExpression() {
      const { _, fieldsExpression } = this;
      let res = {};
      _.forEach(fieldsExpression, function (e) {
        let value = _.find(e.data, (i) => i.type == "text" && !i.value["ja"]);
        if (value) return (res = value);
      });

      return res;
    },
    validateValueSentence() {
      const { _, fieldsSentence } = this;
      let value = _.find(fieldsSentence, (i) => {
        console.log("i: ", i);
        return (i.type == "text" || i.isType == "TEXT") && !i.value["ja"];
      });
      return value;
    },
    validateIllustration() {
      const { fieldsExpression, fieldsSentence, _ } = this;
      var res = false;
      _.forEach(fieldsExpression, function (e) {
        _.forEach(e.data, function (item) {
          if (item.key == "Illustration" && !item.file) return (res = true);
        });
      });
      _.forEach(fieldsSentence, function (e) {
        if (e.key == "Illustration" && !e.file) return (res = true);
      });
      return res;
    },
    async zipFile(params) {
      const { fieldsExpression, fieldsSentence, _ } = this;
      var folderImage = new JsZip().folder("image");
      var folderAudio = new JsZip().folder("Audio");
      // Zip file in fields expression
      _.forEach(fieldsExpression, function (e) {
        _.forEach(e.data, function (item) {
          // Zip file image
          if (item.key == "Illustration" && item.file && item.file.file) {
            let file = item.file.file;
            let splitType = file.name.split(".");
            let type = file.name.split(".")[splitType.length - 1];
            let uID = uuidv4();
            let name = `Sentence_${uID}.${type}`;
            item.file_name = `${name}`;
            folderImage.file(`${name}`, file);
          } else if (item.key == "Example" && item.file && item.file.file) {
            let file = item.file.file;
            let splitType = file.name.split(".");
            let type = file.name.split(".")[splitType.length - 1];
            let uID = uuidv4();
            let name = `Sentence_${uID}.${type}`;
            item.file_name = `${name}`;
            folderAudio.file(`${name}`, file);
          }
        });
      });
      // Zip file in fields Sentence
      _.forEach(fieldsSentence, function (e) {
        // Zip file image
        if (e.key == "Illustration" && e.file && e.file.file) {
          let file = e.file.file;
          let splitType = file.name.split(".");
          let type = file.name.split(".")[splitType.length - 1];
          let uID = uuidv4();
          let name = `Sentence_${uID}.${type}`;
          e.file_name = `${name}`;
          folderImage.file(`${name}`, file);
        } else if (e.key == "Example" && e.file && e.file.file) {
          let file = e.file.file;
          let splitType = file.name.split(".");
          let type = file.name.split(".")[splitType.length - 1];
          let uID = uuidv4();
          let name = `Sentence_${uID}.${type}`;
          e.file_name = `${name}`;
          folderAudio.file(`${name}`, file);
        }
      });
      await folderAudio
        .generateAsync({ type: "blob" })
        .then(async (content) => {
          content.name = "SUN.zip";
          await uploadFile(content, "audio").then(async (e) => {
            params.fileNameAudio = e;
          });
        });
      await folderImage
        .generateAsync({ type: "blob" })
        .then(async (content) => {
          content.name = "SUN.zip";
          await uploadFile(content, "image").then(async (e) => {
            params.fileNameImage = e;
          });
        });
      return params;
    },
    async fetchDetail() {
      let params = {
        id: this.$route.params.expression,
        sub_key: this.$route.params.section,
      };
      await getDetailExpression(params).then(({ result }) => {
        const { _ } = this;
        const { data, challenge, vocabulary, status, type } = result;
        // formart url
        _.forEach(data, function (e) {
          _.forEach(e.data, function (item) {
            if (item.key == "Illustration" && item.file) {
              item.file.fileUrl = `${item.image_url}`;
              delete item.file.file;
              delete item.file.formData;
            }
            if (item.key == "Example" && item.file) {
              item.file.fileUrl = `${item.audio_url}`;
              delete item.file.file;
              delete item.file.formData;
            }
          });
        });

        _.forEach(challenge, function (item) {
          if (item.key == "Illustration" && item.file) {
            item.file.fileUrl = `${item.image_url}`;
            delete item.file.file;
            delete item.file.formData;
          }
          if (item.key == "Example" && item.file) {
            item.file.fileUrl = `${item.audio_url}`;
            delete item.file.file;
            delete item.file.formData;
          }
        });

        this.fieldsExpression = data;
        this.fieldsSentence = challenge;
        this.vocabularySentence = vocabulary;
        this.statusSentence = status;
        this.isType = type;
        this.$route.meta.title = `${
          this.items.find((e) => e.value == this.isType).text
        }編集`;
      });
    },
    async hanldeUpdate() {
      const {
        fieldsExpression,
        fieldsSentence,
        vocabularySentence,
        isType,
        statusSentence,
        _,
      } = this;
      const that = this;
      this.$toast.clear();
      // Check validate value type text Expression
      let validateValueExpression = this.validateValueExpression();
      if (!_.isEmpty(validateValueExpression)) {
        await FromExpression.methods.validate(validateValueExpression);
        this.$refs[`From${isType}`].handleCheckValidate();
        return this.$toast.error("タイトルが項目必須です。入力してください。");
      }
      // Check validate value type text Expression
      let validateValueSentence = this.validateValueSentence();
      if (!_.isEmpty(validateValueSentence)) {
        await FromSentence.methods.validate(validateValueSentence);
        this.$refs[`From${isType}`].handleCheckValidate();
        return this.$toast.error(
          "多言語がある項目の日本語を入力してください。"
        );
      }
      // Check validate title
      let validateTitle = this.validateTitle();
      if (!validateTitle) {
        this.$store.tabExpression = "forms";
        this.$store.activeFieldExpression = {};
        return this.$toast.error("タイトルが項目必須です。入力してください。");
      }
      // Check validate illustration
      let validateIllustration = this.validateIllustration();
      if (validateIllustration) {
        this.$store.tabExpression = "forms";
        this.$store.activeFieldExpression = {};
        return this.$toast.error("挿絵データをアップロードしてください。");
      }
      // Delete form []
      _.forEach(fieldsExpression, function (e, index) {
        if (e.data.length == 0) {
          that.$delete(fieldsExpression, index);
        }
      });
      // _.forEach(fieldsSentence, function (e, index) {
      //   console.log("e: ", e);
      //   if (e.data.length == 0) {
      //     that.$delete(fieldsSentence, index);
      //   }
      // });
      this.loading = true;

      let data = [];
      let challenge = [];
      fieldsExpression.forEach((e) => data.push(e));
      fieldsSentence.forEach((e) => challenge.push(e));
      let params = {
        data: data,
        challenge,
        vocabulary: vocabularySentence,
        section_id: this.$route.params.section,
        type: isType,
        id: this.$route.params.expression,
        status: statusSentence,
      };
      params = await this.zipFile(params);
      await updateExpression(params).catch(() => (this.loading = false));
      this.$router.go(-1);
      this.loading = false;
    },
    inputType(e) {
      const { fieldsExpression, fieldsSentence } = this;
      if (fieldsExpression.length > 0 || fieldsSentence.length > 0) {
        this.dialogComfirm = true;
      } else {
        this.isType = e;
      }
    },
    handleChangeType() {
      if (this.isType == "Sentence") {
        this.isType = "Expression";
      } else {
        this.isType = "Sentence";
      }
      this.fieldsExpression = [];
      this.fieldsSentence = [];
      this.activeFieldExpression = {};
      this.activeTabForFieldsExpression = "elements";
      this.mainExpression = "Edit";
      this.dialogComfirm = false;
    },
    handleCancel() {
      this.keyType++;
      this.dialogComfirm = false;
    },
    changeFieldsSentence(e) {
      if (e.added) {
        e.added.element.id = `${uuidv4()}`;
        this.editElementProperties(e.added.element);
      } else if (e.moved) {
        this.editElementProperties(e.moved.element);
      }
    },
    async editElementProperties(field) {
      if (field.key == "Illustration") {
        this.activeFieldGrammar = {};
        this.activeTabForFieldsGrammar = "elements";
      } else {
        this.tab = "properties";
      }
      if (this.isType == "Expression") {
        FromExpression.methods.editElementProperties(field);
      } else {
        FromSentence.methods.editElementProperties(field);
      }
    },
  },
  beforeDestroy() {
    this.fieldsExpression = [];
    this.activeFieldExpression = {};
    this.activeTabForFieldsExpression = "elements";
    this.mainExpression = "Edit";
    this.isType = "Expression";
    this.fieldsSentence = [];
    this.vocabularySentence = [];
    this.statusSentence = false;
  },
};
</script>
